import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * PasswordInput — single password field with a persistent eye toggle.
 * Drop-in replacement for a plain <input type="password">. Preserves the
 * regal styling used across Login / Register / Reset pages.
 */
export const PasswordInput = ({
  id,
  value,
  onChange,
  placeholder = "••••••••",
  required = true,
  testid,
  autoComplete = "current-password",
  className = "",
}) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        id={id}
        type={visible ? "text" : "password"}
        required={required}
        value={value}
        onChange={onChange}
        data-testid={testid}
        autoComplete={autoComplete}
        placeholder={placeholder}
        className={
          "w-full bg-obsidian border border-seam rounded-md pl-4 pr-11 py-3 text-textmain " +
          "placeholder-[#52525B] focus:outline-none focus:border-champagne " +
          "focus:ring-1 focus:ring-champagne/40 transition-colors " +
          className
        }
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible((v) => !v)}
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
        aria-label={visible ? "Hide password" : "Show password"}
        title={visible ? "Hide password" : "Show password"}
        className="absolute inset-y-0 right-2 my-auto h-9 w-9 flex items-center justify-center rounded text-textmuted hover:text-champagne transition-colors"
      >
        {visible ? <EyeOff className="w-4 h-4" strokeWidth={1.6} /> : <Eye className="w-4 h-4" strokeWidth={1.6} />}
      </button>
    </div>
  );
};

export default PasswordInput;
